<template>
	<el-dialog
		:title="title || '系统提醒'"
		:visible.sync="dialogVisible"
		@close="close"
		:close-on-click-modal="closeOnClickModal"
		:width="width + 'px'"
	>
		<WaringMessage :option="renderFn"></WaringMessage>
		<p class="message" :style="`text-align: ${textAlign}`">{{ message }}</p>
		<span slot="footer" class="dialog-footer">
			<el-button
				type="primary"
				v-focus="true"
				:class="{ disabled: !confirmCanClick, danger: danger }"
				:disabled="!confirmCanClick"
				@click="confirm"
				>{{ confirmText || '确认' }}</el-button
			>
			<el-button class="btn cancel" v-if="isShowCancelBtn" @click="close"
				>取消</el-button
			>
		</span>
	</el-dialog>
</template>

<script>
export default {
	data() {
		return {
			dialogVisible: false,
		}
	},

	created() {
		this.timer = null
		// window.addEventListener('keydown', this.keydownEvent)
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('hashchange', this.close)
		})
	},

	beforeDestroy() {
		window.removeEventListener('hashchange', this.close)
		// window.removeEventListener('keydown', this.keydownEvent)
	},

	props: {
		danger: {
			type: Boolean,
			default: false,
		},
		title: String,
		message: String,
		textAlign: {
			type: String,
			default: 'center',
		},
		html: String,
		confirmText: String,
		confirmCanClick: {
			type: Boolean,
			default: true,
		},
		renderFn: {
			type: Function,
			required: false,
		},
		closeOnClickModal: {
			type: Boolean,
			default: true,
		},
		isShowCancelBtn: {
			type: Boolean,
			default: true,
		},
		width: {
			type: Number,
			default: 430,
		},
	},

	methods: {
		keydownEvent(e) {
			if (e.keyCode === 13) {
				this.confirm()
			}
		},

		open() {
			this.dialogVisible = true
		},

		confirm() {
			if (this.timer) clearTimeout(this.timer)
			this.timer = setTimeout(() => {
				this.dialogVisible = false
				this.$emit('confirm')
			}, 100)
		},

		close() {
			this.dialogVisible = false
			this.$emit('cancel')
		},
	},
	components: {
		WaringMessage: {
			props: {
				option: {
					type: Function,
					required: false,
				},
			},

			render(h, context) {
				if (this.option) return this.option(h)
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.message {
	font-size: 16px;
	line-height: 20px;
	color: #333;
	letter-spacing: 0;
}

.disabled {
	background: #ddd !important;
	cursor: not-allowed;
}

.danger {
	background: #e51c23 !important;
	color: #fff;
	border-color: #e51c23;
	outline: unset;
	&:hover {
		border-color: #e51c23;
	}
	&:focus {
		border-color: #e51c23 !important;
	}
}

::v-deep .el-dialog .el-dialog__footer {
	height: 60px;
	padding: 0;
	text-align: center;
	line-height: 60px;
	.el-button {
		width: 100px;
    height: 36px;
    padding: 0;
    text-align: center;
    line-height: 36px;
	}
}

::v-deep .el-dialog .el-dialog__body {
	padding: 20px 20px 8px 20px !important;
}
</style>
